import { render, staticRenderFns } from "./ServiceListTableForm.vue?vue&type=template&id=27fb0e7e&"
import script from "./ServiceListTableForm.vue?vue&type=script&lang=js&"
export * from "./ServiceListTableForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports